import React, { useState, useCallback, useEffect } from 'react';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterImg = withEnterToClick('img');

// Table component used for displaying
// Landing page models
// grading tool results
const Table = ({
  TableRow,
  tableColumns,
  data,
  title,
  subtitle,
  searchInput,
  setSearchInput,
  filterData,
  defaultSort,
  searchable,
  getKey,
}) => {
  const t = useT();
  const [sortedData, setSortedData] = useState(data);
  const [sortedKey, setSortedKey] = useState(defaultSort);
  const [sortedDirection, setSortedDirection] = useState('ascending');

  const setArrowDirection = key => {
    if (key === sortedKey && sortedDirection === 'ascending') {
      return require('~app/resources/images/icons/chevron-up-black.svg');
    }
    return require('~app/resources/images/icons/chevron-down-black.svg');
  };

  const columnHeaderProps = col => {
    if (col?.sortable) {
      return {
        //'aria-sort': sortedDirection,
      };
    }
    return {};
  };

  useEffect(() => {
    const sign = sortedDirection === 'ascending' ? 1 : -1;
    setSortedData(
      data.slice().sort(function (a, b) {
        a = a[sortedKey];
        b = b[sortedKey];
        return (a === b ? 0 : a > b ? 1 : -1) * sign;
      }),
    );
  }, [data, sortedKey, sortedDirection, setSortedData]);

  const setSortBy = useCallback(
    key => {
      if (key === sortedKey) {
        if (sortedDirection === 'ascending') {
          setSortedDirection('descending');
        }
        if (sortedDirection === 'descending') {
          setSortedDirection('ascending');
        }
      } else {
        setSortedDirection('ascending');
      }
      setSortedKey(key);
    },
    [sortedDirection, sortedKey],
  );

  return (
    <table className="Table__element">
      <caption className="Table__title">
        {title}
        <div className="Table__subtitle mb-0">{subtitle}</div>
      </caption>
      <thead>
        <tr className="Table__header-row">
          {tableColumns.map(col => (
            <th
              key={col.name}
              className={col.className}
              role="columnheader"
              {...columnHeaderProps(col)}
            >
              {col.sortable && (
                <ClickOrEnterImg
                  className={`Table__arrow ${
                    sortedKey === col.name ? '' : 'disabled'
                  }`}
                  src={setArrowDirection(col.name)}
                  onClick={() => setSortBy(col.name)}
                  role="button"
                  alt={col.alt}
                  tabIndex="0"
                  //aria-label={`${col.title} sorted in ${sortedDirection}`}
                  //A3MG NEW 12/11/23
                  aria-label={`${sortedKey === col.name ? '' : 'Sort'} ${
                    col.title
                  }${sortedKey === col.name ? ' sorted by ' : ' by ascending'}${
                    sortedKey === col.name ? sortedDirection : ''
                  }`}
                  //END A3MG 12/11/23
                />
              )}
              {col.title}
            </th>
          ))}
          {searchable && (
            <td className="Table__col-download">
              <span className="Table__search-text" aria-hidden="true">
                Search
              </span>
              <span className="Table__search-box">
                <input
                  type="search"
                  name={t('search')}
                  className="Table__search-input"
                  placeholder="Enter search term"
                  value={searchInput}
                  onChange={e => setSearchInput(e.target.value.toLowerCase())}
                  tabIndex="0"
                />
              </span>
            </td>
          )}
        </tr>
      </thead>
      <tbody className="Table__content">
        {sortedData
          .filter(sortedDatum => filterData(sortedDatum))
          .map(filteredSortedDatum => (
            <TableRow
              key={getKey(filteredSortedDatum)}
              rowData={filteredSortedDatum}
            />
          ))}
      </tbody>
    </table>
  );
};

export default Table;
